import { ReactElement, useState } from 'react'
import { Stack, Tab, Tabs } from '@mui/material'
import { PopoverPanel } from '@ui2/structure'
import ConnectionTab from './ConnectionTab'
import InstructionsTab from './InstructionsTab'

type AIAccessTabValue = 'instructions' | 'connection'

interface Props {
  anchorEl: HTMLElement
  onClose: () => void
}

const AIAccessPopover = ({ anchorEl, onClose }: Props): ReactElement => {
  const [tab, setTab] = useState<AIAccessTabValue>('instructions')

  return (
    <PopoverPanel anchorEl={anchorEl} onClose={onClose} title="KI-Zugriff" dataCy="ai-access-panel">
      <Stack spacing={1.5} sx={{ width: 340 }}>
        <Tabs
          value={tab}
          onChange={(_, value: AIAccessTabValue) => setTab(value)}
          variant="fullWidth"
          sx={{ minHeight: 32 }}
        >
          <Tab
            value="instructions"
            label="Instruktionen"
            sx={{ minHeight: 32, py: 0.5 }}
            data-cy="ai-access-tab-instructions"
          />
          <Tab
            value="connection"
            label="Verbindung"
            sx={{ minHeight: 32, py: 0.5 }}
            data-cy="ai-access-tab-connection"
          />
        </Tabs>
        {tab === 'instructions' ? <InstructionsTab /> : <ConnectionTab />}
      </Stack>
    </PopoverPanel>
  )
}

export default AIAccessPopover
